import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchTicketsData = (retailerId) => {
  const { url } = DepsService.rest.widgets.tickets;
  const queryParams = {};
  const urlParams = {
    retailerId,
  };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/tickets.api.js